// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Inputs-Select-styles___selected--Cuhfx .components-Inputs-Select-styles___endText--oTZIf {
    position: absolute;
    right: 45px;
  }
    .components-Inputs-Select-styles___selected--Cuhfx .components-Inputs-Select-styles___endText--oTZIf p {
      font-size: 11px;
      color: #6d717a;
      letter-spacing: 0;
    }
  .components-Inputs-Select-styles___selected--Cuhfx div svg {
      transform: rotate(180deg);
      top: calc(50% - 8px);
      right: 11px;
      color: rgba(0, 0, 0, 0.54);
      position: absolute;
      pointer-events: none;
      font-size: 18px;
    }

.components-Inputs-Select-styles___select--Jlave .components-Inputs-Select-styles___endText--oTZIf {
    position: absolute;
    right: 45px;
  }

.components-Inputs-Select-styles___select--Jlave .components-Inputs-Select-styles___endText--oTZIf p {
      font-size: 11px;
      color: #6d717a;
      letter-spacing: 0;
    }

.components-Inputs-Select-styles___select--Jlave div svg {
      top: calc(50% - 8px);
      right: 11px;
      color: rgba(0, 0, 0, 0.54);
      position: absolute;
      pointer-events: none;
      font-size: 18px;
    }
`, "",{"version":3,"sources":["webpack://./components/Inputs/Select/styles.pcss"],"names":[],"mappings":"AACE;IACE,kBAAkB;IAClB,WAAW;EAMb;IALE;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;IACnB;EAGA;MACE,yBAAyB;MACzB,oBAAoB;MACpB,WAAW;MACX,0BAA0B;MAC1B,kBAAkB;MAClB,oBAAoB;MACpB,eAAe;IACjB;;AAKF;IACE,kBAAkB;IAClB,WAAW;EAMb;;AALE;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;IACnB;;AAGA;MACE,oBAAoB;MACpB,WAAW;MACX,0BAA0B;MAC1B,kBAAkB;MAClB,oBAAoB;MACpB,eAAe;IACjB","sourcesContent":[".selected {\n  .endText {\n    position: absolute;\n    right: 45px;\n    p {\n      font-size: 11px;\n      color: #6d717a;\n      letter-spacing: 0;\n    }\n  }\n  div {\n    svg {\n      transform: rotate(180deg);\n      top: calc(50% - 8px);\n      right: 11px;\n      color: rgba(0, 0, 0, 0.54);\n      position: absolute;\n      pointer-events: none;\n      font-size: 18px;\n    }\n  }\n}\n\n.select {\n  .endText {\n    position: absolute;\n    right: 45px;\n    p {\n      font-size: 11px;\n      color: #6d717a;\n      letter-spacing: 0;\n    }\n  }\n  div {\n    svg {\n      top: calc(50% - 8px);\n      right: 11px;\n      color: rgba(0, 0, 0, 0.54);\n      position: absolute;\n      pointer-events: none;\n      font-size: 18px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selected": `components-Inputs-Select-styles___selected--Cuhfx`,
	"endText": `components-Inputs-Select-styles___endText--oTZIf`,
	"select": `components-Inputs-Select-styles___select--Jlave`
};
module.exports = ___CSS_LOADER_EXPORT___;
